const CryptoJS = require('crypto-js'); //引用AES源码js
const key = CryptoJS.enc.Utf8.parse("1234567890123456"); //密钥
// const rdNum = generateMixed()
// const iv = CryptoJS.enc.Latin1.parse(rdNum)
// const iv = CryptoJS.enc.Utf8.parse(rdNum); //十六位数作为密钥偏移量
// 生成随机数 
// function generateMixed() {
// 	var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K',
// 		'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
// 	];
// 	var res = "";
// 	for (var i = 0; i < 16; i++) {
// 		var id = Math.ceil(Math.random() * 35);
// 		res += chars[id];
// 	}
// 	return res;
// }

// function getIV() {
// 	return rdNum
// }


//加密方法
function Encrypt(word) {
	let encrypted = CryptoJS.AES.encrypt(word, key, {
		// iv: iv,
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString()
}

//解密方法1
function Decrypt(word) {
	let decrypt = CryptoJS.AES.decrypt(word, key, {
		// iv: iv,
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return decrypt.toString(CryptoJS.enc.Utf8);

}


export default {
	Decrypt,
	Encrypt,
	// generateMixed,
	// getIV
}



// WEBPACK FOOTER //
// ./src/utils/signature.js